<iframe
    #iframe
    id="iframe-external-login"
    allow="fullscreen"
    referrerpolicy="no-referrer"
    frameborder="0"
    allowtransparency
>
    Your browser does not support iFrames
</iframe>
